module.exports = __webpack_public_path__ + "img/icon-file-analytics-active.fc7cf52c.svg";